<template lang="pug">
  .component-add-parking-lot
    .row.columns.callout
      h6 Add new Parking Lot
      h3 Selected Parking Group: {{item.name}}
      .row
        .column
          label Name
            input(type="text", v-model="name")
          label Available slots
            input(type="text", v-model="availableSlots")
          label Allowed Zone
            select(v-model="allowed_zone_id")
              option(:value="null") Not Selected
              option(v-for="zone in zones", :value="zone.id") {{zone.name}}
          label Undesirable Zone
            select(v-model="undesiderable_zone_id")
              option(:value="null") Not Selected
              option(v-for="zone in zones", :value="zone.id") {{zone.name}}
          label Forbidden zone
            select(v-model="forbidden_zone_id")
              option(:value="null") Not Selected
              option(v-for="zone in zones", :value="zone.id") {{zone.name}}
        .column
          label Description
          Editor(v-model="description", :value="description")
          label Picture
            input(type="text", v-model="picture")
          kepler-file-upload(@sel="handleFileSelector", selected-prefix="parking-lot", selected-visibility="public")


      .row
        .column
          label Latitude
            input(type="number", v-model="latitude")
        .column
          label Longitude
            input(type="number", v-model="longitude")
      button.button.small(@click="openMap = !openMap") Toggle Map

      .row.columns(v-if="openMap")
        label Click on the map for select the parking lot position
        .map-wrapper
          GoogleMapContainer
            GoogleMap(:apiKey="mapKey", :center="mapCenter", :searchBar="true",:mapTypeId="'roadmap'", :mapTypeControl="true", :listenForClick="true", @mapClicked="updateMarker", @placesChanged="hideMarker")
              GoogleMapMarker(v-if="markerPosition", :position="mapCenter", title="", label="")
              .polygons(v-if="undesiderable_zone_id")
                GoogleMapPolygon(v-for="p in zones[undesiderable_zone_id].poly", :positions="p", color="yellow", fillColor="yellow")
              .polygons(v-if="forbidden_zone_id")
                GoogleMapPolygon(v-for="p in zones[forbidden_zone_id].poly", :positions="p", color="red", fillColor="red")
              .polygons(v-if="allowed_zone_id")
                GoogleMapPolygon(v-for="p in zones[allowed_zone_id].poly", :positions="p", color="green", fillColor="green")
        p {{latitude}} {{longitude}}


      .row.column
        button.button(:class="{disabled:!description || !name ||!latitude || !longitude}", @click="addParkingLot") Add

</template>

<script>
  import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
  import MaggieHelper from "../../../../maggieHelper";
  import KeplerFileUpload from "../../KeplerFileUpload";
  import GoogleMap from "../../../../lib/map/GoogleMap.vue";
  import GoogleMapMarker from "../../../../lib/map/GoogleMapMarker.vue"
  import GoogleMapPolygon from "../../../../lib/map/GoogleMapPolygon.vue"
  import Editor from "../Editor";
  import GoogleMapContainer from '../../../backoffice/GoogleMapContainer'

  export default {
    name: "CreateParkingLot",
    components: {GoogleMapContainer, Editor, KeplerFileUpload, GoogleMap, GoogleMapMarker, GoogleMapPolygon},
    data() {
      return {
        showFileSelector: false,
        name: null,
        description: "",
        availableSlots: 0,
        latitude: null,
        longitude: null,
        allowed_zone_id: null,
        forbidden_zone_id: null,
        undesiderable_zone_id: null,
        picture: null,

        openMap: false,
        marker: {},
        zones: null,
        mapCenter: {
          lat: 0,
          lng: 0,
        },
        markerPosition: {
          lat: 0,
          lng: 0,
        }
      }
    },
    mounted() {
      KeplerBackofficeSdk.configuration.get((data) => {
        this.mapCenter.lat = data.application.application_default_latitude.value
        this.mapCenter.lng = data.application.application_default_longitude.value
      })

    },
    created() {
      this.getZones()
    },
    methods: {
      hideMarker() {
        this.markerPosition = false
      },
      updateMarker(e) {
        this.markerPosition = true
        this.mapCenter.lat = e.lat()
        this.mapCenter.lng = e.lng()
        this.latitude = e.lat()
        this.longitude = e.lng()
      },
      handleFileSelector(path) {
        this.picture = path
        this.showFileSelector = false
      },
      addParkingLot() {
        var body = {
          name: this.name,
          description: this.description,
          parking_group_id: this.item.id,
          slots: this.availableSlots,
          latitude: this.latitude,
          longitude: this.longitude,
          picture: this.picture,
          allowed_zone_id: this.allowed_zone_id,
          forbidden_zone_id: this.forbidden_zone_id,
          undesiderable_zone_id: this.undesiderable_zone_id,
        }

        KeplerBackofficeSdk.parkingLots.make(body, (data) => {
          MaggieHelper.notification('add-esit', 'Parking lot added successfully')
          this.$router.push({name: 'parkingLot', params: {id: data.id}})
        })
      },
      addPin(e) {
        this.latitude = e.lat()
        this.longitude = e.lng()
      },
      getZones() {

        KeplerBackofficeSdk.zones.list.all((data) => {
          this.zones = data
        })
      }
    },
    computed: {
      mapKey() {
        return window.env.GOOGLE_MAPS_KEY
      }
    },
    props: ['item']
  }
</script>

<style scoped lang="sass" rel="stylesheet/sass">
  .map-wrapper
    height: 600px
</style>



// WEBPACK FOOTER //
// CreateParkingLot.vue?dd6140a4